import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'antd';

@inject('store')
@observer
export class AuthView extends Component {
    async componentDidMount() {
        try {
            await this.props.store.userStore.handleAuthentication();
            this.props.history.push('/a/bots');
        } catch (e) {
            Modal.error({
                title: 'Authentication error',
                content: JSON.stringify(e),
                onOk: () => {
                    this.props.store.userStore.login();
                }
            });
        }
    }

    render() {
        return <div />;
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthView.js